<template>
  <div class="distribution">
    <el-button type="text" size="medium" @click="$router.go(-1)">返回</el-button><br>
    <el-input class="search-el" size="mini" v-model="query.nickname" clearable placeholder="请输入用户昵称"></el-input>
    <el-select class="search-el" size="mini" v-model="query.target_id" clearable placeholder="课程名称">
      <el-option label="全部" value="">全部</el-option>
      <el-option :label="item.title" :value="item.target_id" v-for=" item in calssArr" :key="item.id">{{ item.title }}</el-option>
    </el-select>
    <el-date-picker size="mini" v-model="query.begin_at" type="datetime" placeholder="开始日期" @change="changeHandel">
    </el-date-picker>
    ~
    <el-date-picker size="mini" v-model="query.end_at" type="datetime" placeholder="结束日期" @change="changeHandel2">
    </el-date-picker>
    <el-button type="primary" size="mini" @click="getList()" style="margin-left: 20px;"> 查询</el-button>
    <el-button type="primary" size="mini" @click="exportList()"> 导出</el-button>
    <div style="color: red; margin: 10px 0;">提示：首页数据默认为今日数据</div>
    <el-row>
      <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true"
        style="width: 100%; margin: 10px 0">
        <el-table-column label="分享人昵称" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div @click.stop="toinfo(row.user_id)" style="color: #409eff;">{{ row.nickname }}</div>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div @click.stop="toinfo(row.user_id)" style="color: #409eff;">{{ row.user_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="分享课程名称" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div @click="couresinfo(row.target_id)" style="color: #409eff;">{{ row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="下单人数" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div @click="$router.push(`/distribution/purchasepeople?id=${query.activity_distribution_id}&userid=${row.user_id}&targetid=${row.target_id}`)"
              style="color: #409eff;">{{ row.order_num }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="bott">
      <el-pagination background layout="prev, pager, next" :total="totalItems" :page-size="pageSize"
        :current-page="currentPage" @current-change="handlePageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getShareList,getRelationshipList } from "@/api/distribution"
const axios = require('axios');
export default {
  data() {
    return {
      query: {
        nickname: '',
        begin_at: '',
        end_at: '',
        activity_distribution_id: this.$route.query.id,
        limit: 10,
        page: 1,
        target_id:'',
      },
      currentPage: 1, // 当前页
      pageSize: 10, // 一页几条
      totalItems: 0,
      tableData: [],
      loading: false,
      calssArr:[],
      page:1,
      limit:9999,
      user_id:null
    }
  },
  mounted() {
    this.loading = false
    this.getList()
    this.couresHandel()
  },
  methods: {
    getidHandel() {
      console.log(this.user_id);
    },
    getList() { // 查询列表 
      getShareList(this.query).then((res) => {
        console.log(res);
        this.tableData = res.data.list
        this.totalItems = res.data.total
        console.log(this.user_id);
      })
      console.log(this.query);
      
    },
    changeHandel(value) {

      this.query.begin_at = this.dateHandel(value)
      console.log(this.query.begin_at, value, this.query);
    },
    couresHandel(){
      getRelationshipList({ activity_distribution_id: this.query.activity_distribution_id,page:this.page,limit:this.limit }).then((res) => {
        this.calssArr = res.data.list

      })
    },
    changeHandel2(value) {
      this.query.end_at = this.dateHandel(value)
      console.log(this.query.end_at, value, this.query);
    },
    dateHandel(date) {


      // 使用 Date 对象的方法获取年、月、日
      let year = date.getFullYear();
      let month = date.getMonth() + 1; // 月份从 0 开始，所以要加 1
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      // 将月份和日期转换成两位数的字符串，不足两位的在前面补 0
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      // 将年、月、日拼接成 YYYY-MM-DD 格式的字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    },
    handlePageChange(currentPage) {
      this.query.page = currentPage;
      this.getList()
    },
    toinfo(id) {
      this.$router.push({
        path: "/user/info",
        query: {
          id: id,
        }
      });
    },
    couresinfo(id){
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open(`http://dev.admin.defen.hzxinquanzi.com/?c=course&m=course_list&p=31&title=${id}`);
      } else {
        window.open(`http://admin.defen.hzxinquanzi.com/?c=course&m=course_list&p=31&title=${id}`);
        // window.open(`http://dev.admin.defen.hzxinquanzi.com/?c=course&m=course_list&p=31&title=${id}`);
      }
    },
    exportList() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/activity/distribution/getShareList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '分销活动-今日分享人数列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }
  },
}
</script>

<style scoped>
.distribution {
  padding: 20px 30px;
  cursor: pointer;
}
</style>